import { render, staticRenderFns } from "./PreOrdersDetails.vue?vue&type=template&id=5e61288a&scoped=true"
import script from "./PreOrdersDetails.vue?vue&type=script&lang=js"
export * from "./PreOrdersDetails.vue?vue&type=script&lang=js"
import style0 from "./PreOrdersDetails.vue?vue&type=style&index=0&id=5e61288a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e61288a",
  null
  
)

export default component.exports